// extracted by mini-css-extract-plugin
export default {"breadCrumbWrap":"BreadCrumbsWrap_breadCrumbWrap__P76US"};